import Slider from 'react-slick';
import "./ImageSlider.css";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const settings = {
    dots: false,
    arrows: true, 
    infinite: true,
    speed: 500,
    slidesToShow:2,
    slidesToScroll: 1,
    swipeToSlide: true,
    centerMode: true,
};

const ProductSlider = () => (
    <Slider {...settings} className="flex">
        {/*<img src="/products/product-sara-0.png" alt="" className=" h-[500px]  object-contain " />
        <img src="/products/product-sara-1.png" alt="" className=" h-[500px] object-contain " />
        <img src="/products/product-sara-2.png" alt="" className=" h-[500px] object-contain " />*/}
        <img src="/products/1.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/2.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/3.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/4.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/5.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/6.jpg" alt="" className="h-[500px] object-contain " />
        <img src="/products/7.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/8.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/9.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/10.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/11.jpg" alt="" className=" h-[500px] object-contain " />
        <img src="/products/12.jpg" alt="" className=" h-[500px] object-contain " />
        
        <img src="/products/13.png" alt="" className=" h-[500px] object-contain " />
        <img src="/products/14.png" alt="" className=" h-[500px] object-contain " />
        <img src="/products/15.png" alt="" className=" h-[500px] object-contain " />

    </Slider>
);





export default ProductSlider;